// extracted by mini-css-extract-plugin
module.exports =  {"container":"c85e813ac9--container--Oy7T5","tablet":"c85e813ac9--tablet--nI3Dk","list":"c85e813ac9--list--LbiKh","phone":"c85e813ac9--phone--KvZyZ","btn":"c85e813ac9--btn--yX2qi"};